// Las resoluciones de video y el BORRADOR, en un solo lugar
// (ADR-2026-09-27-borrador-480p-y-pasar-a-1080p). Antes la lista vivía copiada en ocho
// archivos; el borrador la habría vuelto a partir. Puro: sin React ni Supabase.
import { creditsForVideoGeneral, videoGeneralRatePerSec } from '../utils/credits';

export type ResolucionDeVideo = '480p' | '720p' | '1080p';
export const RESOLUCIONES_VIDEO: readonly ResolucionDeVideo[] = ['480p', '720p', '1080p'];

export const ETIQUETA_BORRADOR = 'Borrador';
export const AYUDA_BORRADOR =
  'Genera el video en baja resolución para probar la idea. Cuando te guste, lo pasás a 1080p y sale la misma toma en alta.';
export const ROTULO_PASAR_A_1080P = 'Pasar a 1080p';

/** Borrador = Profesional + 480p (Seedance 2.5 tiene draft mode; Estándar no). Sin calidad
 *  dicha vale la default del agente, Profesional. */
export function esBorrador(calidad: string | null | undefined, resolucion: string | null | undefined): boolean {
  return (calidad ?? 'profesional') === 'profesional' && resolucion === '480p';
}

export interface BorradorDeFila {
  venceEl: string;
  segundos: number;
  finalVideoId: string | null;
}

/** Lo que el backend dejó en `datos_generacion.borrador` (nunca el draft_id: no viaja al front). */
export function borradorDe(datosGeneracion: unknown): BorradorDeFila | null {
  const b = (datosGeneracion as { borrador?: Record<string, unknown> } | null)?.borrador;
  if (!b || typeof b.vence_el !== 'string') return null;
  return {
    venceEl: b.vence_el,
    segundos: typeof b.segundos === 'number' ? b.segundos : 0,
    finalVideoId: typeof b.final_video_id === 'string' ? b.final_video_id : null,
  };
}

export function borradorVigente(datosGeneracion: unknown, ahora: Date = new Date()): boolean {
  const b = borradorDe(datosGeneracion);
  return !!b && !b.finalVideoId && new Date(b.venceEl).getTime() >= ahora.getTime();
}

/** La misma tarifa que cobra el backend: 1080p Profesional × segundos del borrador. */
export function creditosDePasarA1080p(segundos: number): number {
  return creditsForVideoGeneral({ durationSec: segundos, model: 'pro', resolution: '1080p' });
}

/** La fila del borrador con su final ya puesto (apaga el botón sin releer la base). */
export function conFinal(datosGeneracion: unknown, finalVideoId: string): Record<string, unknown> {
  const d = (datosGeneracion as Record<string, unknown> | null) ?? {};
  const b = (d.borrador as Record<string, unknown> | undefined) ?? {};
  return { ...d, borrador: { ...b, final_video_id: finalVideoId } };
}

/** El sub-texto de una opción de resolución: precio por segundo en la calidad activa y, en
 *  480p Profesional, que es borrador. */
export function detalleDeResolucion(calidad: 'basica' | 'profesional' | null, res: ResolucionDeVideo): string {
  const modelo = calidad === 'basica' ? 'standard' : 'pro';
  const precio = `${videoGeneralRatePerSec(modelo, res)} cr/s`;
  return esBorrador(calidad, res) ? `${precio} · ${ETIQUETA_BORRADOR}` : precio;
}
